'use client';

import dayjs from 'dayjs';

import { Selectbox } from '@/components/client';
import { useCustomRouter } from '@/hooks/useCustomRouter';

interface TermsSelectboxFooterProps {
  termsList: {
    title?: string;
    contents?: string;
    createAt?: string;
  }[];
  index?: string;
}

export const TermsSelectboxFooter = ({
  termsList,
  index = '0',
}: TermsSelectboxFooterProps) => {
  const router = useCustomRouter();

  return (
    <Selectbox
      className="w-full"
      float="top"
      options={termsList.map(({ title, createAt }, index) => {
        if (!(title && createAt)) throw new Error('잘못된 약관 데이터입니다.');

        return {
          label: `${title} (${dayjs(createAt).format('YYYY-MM-DD')})`,
          value: String(index),
        };
      })}
      value={index}
      onChange={(e) => {
        router.replace(`?index=${e.value}`);
      }}
    />
  );
};
